/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEventBus } from "@src/store/EventStore";
import { useEffect } from "react";


export function useSubscribe<T = any>(
      type: any,
      handler: (payload: T) => void
) {
      const subscribe = useEventBus((s) => s.subscribe);

      useEffect(() => {
            const unsubscribe = subscribe(type, handler);
            return () => unsubscribe();
      }, [type, handler, subscribe]);
}
